import React from 'react';

import RichTextEditor from 'components/inputs/rich-text-editor/RichTextEditor';

type Props = {
  pitch?: string | null
};

const ProfilePitch = ({ pitch }: Props) => {
  if (!pitch) {
    return null;
  }

  return (
    <section className="profile-pitch text-preserve-whitespaces text-overflow-wrap">
      <RichTextEditor
        key={pitch}
        canEdit={false}
        value={pitch}
      />
    </section>
  );
};

export default ProfilePitch;
